import React, { useMemo } from 'react';
import { SendoutInterviewForm } from 'features/sendouts/components/forms/SendoutInterviewForm';
import {
  INTERVIEW_CALL_TITLE_BY_TYPE,
  INTERVIEW_CALL_TYPES
} from 'features/sendouts/constants/constants';
import strings from 'strings';
import {
  DebriefingCalls as DebriefingCallsForm,
  PreparationCalls as PreparationCallsForm
} from 'UI/components/organisms/InterviewDetailsDrawer/components';
import { formatDefaultValues } from 'UI/components/organisms/InterviewDetailsDrawer/utils';
import TabsView from 'UI/components/templates/TabsView';

import { TAB_IDS } from '../SendoutInterviewDrawer.constants';

import { DebriefingCallReadOnly } from './DebriefingCallReadOnly';
import { InterviewDetailsTabContent } from './InterviewDetailsTabContent';
import { PreparationCallReadOnly } from './PreparationCallReadOnly';
import { useStyles } from './SendoutInterviewDetailsTabs.styled';
import { TabContent } from './TabContent';

const COPIES = strings.sendoutsV2.drawers.sendoutInterviewDetails;

const buildCallTabPresentation = ({ callType, formContent, ReadOnly }) => ({
  formContent,
  emptyCallMessage: strings.formatString(COPIES.emptyCall, {
    callName: INTERVIEW_CALL_TITLE_BY_TYPE[callType]
  }),
  renderReadOnly: record => (
    <ReadOnly values={record ? formatDefaultValues({ data: record }) : null} />
  )
});

const TAB_PRESENTATION = {
  [TAB_IDS.InterviewDetails]: {
    formContent: <SendoutInterviewForm allowPastDate />,
    emptyCallMessage: null,
    renderReadOnly: record => <InterviewDetailsTabContent details={record} />
  },
  [TAB_IDS.PreparationCall]: buildCallTabPresentation({
    callType: INTERVIEW_CALL_TYPES.Preparation,
    formContent: <PreparationCallsForm />,
    ReadOnly: PreparationCallReadOnly
  }),
  [TAB_IDS.DebriefingCall]: buildCallTabPresentation({
    callType: INTERVIEW_CALL_TYPES.Debriefing,
    formContent: <DebriefingCallsForm />,
    ReadOnly: DebriefingCallReadOnly
  })
};

const TAB_DEFINITIONS = [
  { id: TAB_IDS.InterviewDetails, label: COPIES.tabs.interviewDetails.title },
  { id: TAB_IDS.PreparationCall, label: COPIES.tabs.preparationCall.title },
  { id: TAB_IDS.DebriefingCall, label: COPIES.tabs.debriefingCall.title }
];

const buildTabs = props =>
  TAB_DEFINITIONS.map(({ id, label }) => ({
    id,
    label,
    view: <TabContent {...props} presentation={TAB_PRESENTATION[id]} />
  }));

export const SendoutInterviewDetailsTabs = ({
  hasLoadError,
  isEditMode,
  isFetching,
  isFormPreloaded,
  isRecordMissing,
  onChangeTabIndex,
  record,
  selectedTab
}) => {
  const classes = useStyles();
  const tabs = useMemo(
    () =>
      buildTabs({
        hasLoadError,
        isEditMode,
        isFetching,
        isFormPreloaded,
        isRecordMissing,
        record
      }),
    [hasLoadError, isEditMode, isFetching, isFormPreloaded, isRecordMissing, record]
  );

  return (
    <TabsView
      enableUrlNavigation={false}
      onChangeTabIndex={onChangeTabIndex}
      panelHeight="unset"
      selectedTab={selectedTab}
      tabs={tabs}
      useIndexes={false}
      tabsContainerProps={{ className: classes.tabsContainer }}
      padding="24px"
    />
  );
};
